import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function Alert(props) {
  const { isOpen, callBack } = props;

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={callBack}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Уведомление'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Данный функционал находится в процессе разработки. Пожалуйста,
            повторите попытку позднее.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={callBack} variant="contained" color="primary">
            Хорошо
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
